<form class="wrapper">
    @for (option of options; track option) {
    <label
        class="label"
        [style.--color]="option.value"
        [attr.data-color]="option.name"
    >
        <input
            class="input"
            type="radio"
            [value]="option.value"
            [checked]="option.value === value.value"
            name="selectColor[]"
            (change)="onChange(option)"
        />
        <div class="item">
            <i icon class="icon fas fa-check"></i>
        </div>
    </label>
    }
</form>
